import { MouseEvent, useCallback, useId, useState } from "react";

export function useAssistantStepOptions() {
  const [anchor, setAnchor] = useState<HTMLButtonElement | null>(null);

  const id = useId();

  const handleOpen = useCallback((event: MouseEvent<HTMLButtonElement>) => {
    setAnchor(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchor(null);
  }, []);

  const handleSelect = useCallback((action: () => void) => {
    setAnchor(null);
    action();
  }, []);

  return { anchor, id, handleOpen, handleClose, handleSelect };
}
